export default "__VITE_ASSET__CD9AMmg6__"